/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { batchActions } from 'redux-batched-actions';
import { sendErrorMessage } from '@insticator/insticator-ui'; // iui-state
import { getEmbedByUUID } from 'utils/api/embed';
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
import { selectContent } from 'state/actions/embedsState/embedManagementState/content_status';
import { receiveEmbedData } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { receiveContentData } from 'state/actions/embedsState/embedManagementState/content_status';
import { asyncGetEmbedAnalytics } from 'utils/api/embedAnalytics';



/* ========== ~~~~~~~~~~ EMBEDS ANALYTICS : EXPORTS  ~~~~~~~~~~ ========== */
export const SELECT_EMBED_UUID = 'SELECT_EMBED_UUID';
export const FETCHING_ANALYTICS = 'FETCHING_ANALYTICS';
export const RECEIVE_ANALYTICS = 'RECEIVE_ANALYTICS';




/* ++++++++++ --------------- ACTIONS--------------- ++++++++++ */


const fetchingAnalytics = status => ({
    type: FETCHING_ANALYTICS,
    status
});

const receiveAnalytics = data => ({
   type: RECEIVE_ANALYTICS,
   data
});

export const selectEmbedUUID = (embedUUID, embedName) => ({
    type: SELECT_EMBED_UUID,
    embedUUID,
    embedName
});

/* ++++++++++ --------------- BATCHED ACTIONS --------------- ++++++++++ */

const getAnalyticsFail = () => batchActions([fetchingAnalytics(false), sendErrorMessage('There was an issue fetching your analytics')]);
const getAnalyticsSuccess = (data) => batchActions([receiveAnalytics(data), fetchingAnalytics(false)]);


/* ++++++++++ --------------- THUNKS --------------- ++++++++++ */

export const getAnalytics = (embedUUID, filters) => dispatch => {
    dispatch(fetchingAnalytics(true));
    asyncGetEmbedAnalytics(embedUUID, filters)
        .then(response => dispatch(getAnalyticsSuccess(response.data)))
        .catch(err => dispatch(getAnalyticsFail()))
};

export const getEmbedEdit = (embedUUID, contentId) => dispatch => {
    getEmbedByUUID(embedUUID)
        .then(response => dispatch(batchActions([
            receiveEmbedData({ ...response.data.embed, ...response.data.site }),
            receiveContentData(response.data.contents),
        ])))
        .then(response => {
            dispatch(selectContent(contentId));
            dispatch(updatePageDetails('dashboard/embeds/management/customize'));
            dispatch(updateStepDetails('customize'));
            dispatch(changePage(`dashboard/embeds/management/customize`))
        })
};